import Papa from 'papaparse';
import { Client, Databases, Account, Functions } from 'appwrite';  // For Appwrite SDK



const ID = '676d8bf9003d6e9e6572';

const LOCALDB = 'LocalDB'
const WORKOUT_TABLE = 'WorkoutTable'
const YOUR_DATABASE_ID = '6766566a000bee68fa15';
const YOUR_COLLECTION_ID = '676baff1002808a81368';
const FUNCTION_ID_GETTOKEN = '67710e180021859360e1';
const FUNCTION_ID_START = '';
const FUNCTION_ID_GET_DATA = '6772c95400271c87fca2';

const PROJECT_ID = '67664784003af3a2b66d'




// Initialize the Appwrite client
const client = new Client().setProject(PROJECT_ID);
const account = new Account(client);
const databases = new Databases(client);
const functions = new Functions(client);




//---------------------------------------------------------------------------------------------------------------------

export async function app_single_entry(payload) {



    try {

        // Invoke the Appwrite function
        const response = await functions.createExecution(
            ID,
            JSON.stringify(payload),
            false,
            "/",
            "POST",
            {
                "Content-Type": "application/json",
            }
        );

        console.log(response.responseBody);

    } catch (error) {
        console.error("Error submitting data:", error);
        // setMessage(`Failed to submit data: ${error.message}`);
    }

}


//---------------------------------------------------------------------------------------------------------------------



export async function app_bulk_entry(csvFile, userId) {


    try {
        // Read the CSV file using PapaParse
        Papa.parse(csvFile, {
            complete: async (result) => {
                const data = result.data;

                // Skip the first row (header) by slicing the array from the second row
                const formattedData = data.slice(1).map(row => ({
                    title: row[0],        // Assuming title is in the first column
                    start_time: row[1],   // Assuming start_time is in the second column
                    end_time: row[2],     // Assuming end_time is in the third column
                    description: row[3],  // Assuming description is in the fourth column
                    exercise_title: row[4],  // Assuming exercise_title is in the fifth column
                    set_index: parseInt(row[5]),    // Assuming set_index is in the sixth column
                    set_type: row[6],     // Assuming set_type is in the seventh column
                    weight_kg: parseFloat(row[7]),    // Assuming weight_kg is in the eighth column
                    reps: parseInt(row[8]),          // Assuming reps is in the ninth column
                    user_id: userId,
                }));


                console.log(formattedData)

                console.log('Sending payload:', formattedData);


                // Invoke the Appwrite function
                const response = await functions.createExecution(
                    ID,
                    JSON.stringify(formattedData),
                    false,
                    "/",
                    "POST",
                    {
                        "Content-Type": "application/json",
                    }
                );

                // Check if response exists and has a response property
                if (response && response.response) {
                    try {
                        const responseData = JSON.parse(response.response);
                        if (responseData.success) {
                            // setMessage("Data submitted successfully!");
                        } else {
                            // setMessage(`Error: ${responseData.message || 'Unknown error occurred'}`);

                        }
                    } catch (parseError) {
                        console.error("Error parsing response:", response.response);
                        // setMessage("Error processing server response");
                    }
                } else {
                    // setMessage("No response received from server");
                }


            },
            header: false, // Set to true if your CSV has headers
            skipEmptyLines: true, // Skip empty lines
        });
    } catch (err) {
        // setError('An error occurred while processing the CSV file.');
    } finally {
        // setLoading(false);
    }

}




//---------------------------------------------------------------------------------------------------------------------


export async function app_delete_all(params) {

}

//---------------------------------------------------------------------------------------------------------------------

export async function app_console_log(params) { //Get all data and console log it.

}

//---------------------------------------------------------------------------------------------------------------------

export async function app_populate(userId) {

    // !!!!! USER ID FUCNTIONALITY NOT ADDED

    const payload = {
        From_datetime: 'all',
        To_datetime: 'all',
        request_type: 'all',
        
    };


    const response = await functions.createExecution(  // recieved as json string
        FUNCTION_ID_GET_DATA,
        JSON.stringify(payload),
        false,
        "/",
        "GET",
        {
            "Content-Type": "application/json",
        }
    );

    const responseBody = JSON.parse(response.responseBody); //json string parsed
    const data = responseBody.data; // after parsing, the data can be accessed.


    console.log(responseBody);

    console.log('Syncing Complete.');

}

